export enum pathEnum {
  CURRENT_ACCOUNT = 'current-account',
  NOMENCLATURE = 'nomenclature',
  DASHBOARD = '',
  SIMPLE_UPDATE = 'simple-update',
  FINANCING = 'financing',
  AUTOMATED_UPDATE = 'automated-update',
}
